import axios from 'axios';

export default {

    getGpsStatus(menuCode, latitude, longitude, ts, tid, did) {
        return axios.get('/api/qrmenu/gps-status', {
                params: {
                menuCode: menuCode,
                longitude: longitude,
                latitude: latitude,
                ts: ts,
                tid: tid,
                did: did,
            },
        })
        .then(response => {
            if (response && response.data) return response.data
        })
    },

}